import { CommonModule } from '@angular/common';
import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { FormBuilder, FormGroup, FormsModule, ReactiveFormsModule, Validators } from '@angular/forms';
import { unidadesAlimentos } from 'src/app/models/alimento.model';
import { categoriasSuplementos, marcasSuplementos, SuplementoModel } from 'src/app/models/suplemento.model';
import { DocumentsService } from 'src/app/services/document.service';
import { UploadService } from 'src/app/services/upload.service';
import { UtilsService } from 'src/app/services/utils.service';
import { environment } from 'src/environments/environment';
import { Dimensions, ImageCroppedEvent, ImageCropperModule } from 'ngx-image-cropper';
import Swal from 'sweetalert2';
declare var $: any;

@Component({
  selector: 'app-suplementos-d',
  standalone: true,
  imports: [
    CommonModule,
    ReactiveFormsModule, 
    FormsModule,
    ImageCropperModule],
  templateUrl: './suplementos-d.component.html',
  styleUrl: './suplementos-d.component.css'
})
export class SuplementosDComponent  implements OnInit {
  @Input({required: true}) userInfo: any;

  formSuplemento: FormGroup;
  submitFormSuplemento: boolean = false;
  listaSuplementos : any = [];
  marcasSuplementos: any = marcasSuplementos;
  dataTableSuplementos: any;
  unidadesAlimentos: any = unidadesAlimentos;
  categoriasSuplementos: any = categoriasSuplementos;
  editarSuplemento: any = false;
  pattern: string = 'suplemento';

  env: any = environment

  filtroCategoria = '';
  filtroMarca = '';
  filtroPropietario = 'todos'

  constructor(private fb: FormBuilder,
              private documentService: DocumentsService,
              private uploadService: UploadService,
              private utilsService: UtilsService) {
    this.formSuplemento = this.fb.group
    ({
        nombre: ['', [Validators.required]],
        categoria: ['', [Validators.required]],
        marca: [''],
        porcion: ['', [Validators.required, Validators.pattern("^[0-9.]*$")]],
        unidad: ['', [Validators.required]],
        calorias:  ['', [Validators.required, Validators.pattern("^[0-9.]*$")]],
        carbohidratos: ['', [Validators.required, Validators.pattern("^[0-9.]*$")]],
        azucar: ['', [Validators.pattern("^[0-9.]*$")]],
        fibra: ['', [Validators.pattern("^[0-9.]*$")]],
        proteinas: ['', [Validators.required, Validators.pattern("^[0-9.]*$")]],
        grasaTotal: ['', [Validators.required, Validators.pattern("^[0-9.]*$")]],
        grasaSaturada: ['', [Validators.pattern("^[0-9.]*$")]],
        grasaMonoinsaturada: ['', [Validators.pattern("^[0-9.]*$")]],
        grasaPoliinsaturada: ['', [Validators.pattern("^[0-9.]*$")]],
        grasaTrans: ['', [Validators.pattern("^[0-9.]*$")]],
        colesterol: ['', [Validators.pattern("^[0-9.]*$")]],
        informacion: [''],
    })
  }

  ngOnInit(): void {
      this.getSuplementos();
  }

  @Output() messageEvent = new EventEmitter<string>();
  sendSuplementoSelected(suplemento) {
    this.messageEvent.emit(suplemento);
  }

  getSuplementos()
  {
    // debugger
    console.log(this.env)
    const filters: any = {
      //"documentContainerId": this.userInfo.documentContainerId,
      //"empresaId": this.userInfo.empresaId,
      "activo": true
    };
    // GET FILTERS ARRAY
    let filtersQuery: any = this.documentService.getFiltersArray(filters);
    
    if(this.filtroCategoria != '') {
      filtersQuery.push({
        "match_phrase": {
          "categoria.keyword": this.filtroCategoria
        }
      });
    }
    if(this.filtroMarca != '') {
      filtersQuery.push({
        "match_phrase": {
          "marca.keyword": this.filtroMarca
        }
      });
    }
    let should: any = []
    switch (this.filtroPropietario){
      case 'todos':
        should = [
          {
            "match_phrase": {
              "documentContainerId.keyword": this.userInfo.documentContainerId
            }
          },
          {
            "match_phrase": {
              "documentContainerId.keyword": this.env['empresaBaseId']
            }
          }
        ]
        break;
      case 'empresaBase':
        should = [
          {
            "match_phrase": {
              "documentContainerId.keyword": this.env['empresaBaseId']
            }
          }
        ]
        break;
      case 'propios':
        should = [
          {
            "match_phrase": {
              "documentContainerId.keyword": this.userInfo.documentContainerId
            }
          }
        ]
        break;
    }
    filtersQuery.push(
        {
          "bool": { should }
        }
    )
    const query = {
      "sort": [
        {
          "esDocumentDate": {
            "order": "desc",
            "unmapped_type": "boolean"
          }
        }
      ],
      "size": 200,
      "query": {
        "bool": {
          "must": [],
          "filter": filtersQuery,
          "should": [],
          "must_not": []
        }
      }
    };
    setTimeout(() => {
      this.documentService.searchDocument(this.env['empresaBaseId'], this.pattern, query).subscribe({
        next: (data: any) => {
          console.log(data)
          if(this.dataTableSuplementos) {
            this.dataTableSuplementos.destroy();
            this.dataTableSuplementos = null; // Eliminar la referencia
          }
          this.listaSuplementos = [];
          this.listaSuplementos = data;
          this.inicializarDataTableSuplementos();
        },
        error: (error: any) => {
          console.error(error);
          this.inicializarDataTableSuplementos();
        }
      });
    }, 1500);
  }

  inicializarDataTableSuplementos()
  {
    if (this.dataTableSuplementos) {
      this.dataTableSuplementos.destroy(); // Destruir la instancia existente de la DataTable
    }
    $(document).ready(() => {
      this.dataTableSuplementos = $('#dataTable-listaSuplementos').DataTable({
        language: {
          search: "Buscar:",
          lengthMenu: "Mostrar _MENU_ registros",
          info: "Mostrando _START_ al _END_ de _TOTAL_ registros",
          infoEmpty: "Mostrando 0 al 0 de 0 registros",
          infoFiltered: "(filtrados de _MAX_ registros en total)",
          paginate: {
            first: "Primero",
            last: "Último",
            next: "Siguiente",
            previous: "Anterior",
          },
          emptyTable: "No hay datos disponibles en esta tabla"
        },
        pageLength: 10,
      });
    });
  }

  /**************************************************/
  /*********** AGREGAR/EDITAR SUPLEMENTO ************/
  modalSuplemento()
  {
    $('#modal-suplemento').modal({backdrop: 'static', keyboard: false})
    $("#modal-suplemento").modal('show');
  }

  modalEditarSuplemento(suplemento)
  {
    console.log(suplemento)
    this.editarSuplemento = suplemento;
    if(suplemento.imagenProducto) this.previewUrlProducto = suplemento.imagenProducto.url;
    if(suplemento.imagenEtiqueta) this.previewUrlEtiqueta = suplemento.imagenEtiqueta.url;

    this.formSuplemento.setValue({
      nombre: suplemento.nombre,
      categoria: suplemento.categoria,
      marca: suplemento.marca,
      porcion: suplemento.porcion,
      unidad: suplemento.unidad,
      calorias:  suplemento.calorias,
      carbohidratos: suplemento.carbohidratos,
      azucar: suplemento.azucar,
      fibra: suplemento.fibra,
      proteinas: suplemento.proteinas,
      grasaTotal: suplemento.grasaTotal,
      grasaSaturada: suplemento.grasaSaturada, 
      grasaMonoinsaturada: suplemento.grasaMonoinsaturada,
      grasaPoliinsaturada: suplemento.grasaPoliinsaturada,
      grasaTrans: suplemento.grasaTrans,
      colesterol: suplemento.colesterol,
      informacion: suplemento.informacion,
    })
    this.enableOrDisableInputs(false);
    this.modalSuplemento();
  }

  createOrUpdateSuplementoFn() {
    this.submitFormSuplemento = true;
    if(this.formSuplemento.invalid)
    {
      Swal.fire('Advertencia', 'Verifica que los campos sean válidos.', 'warning');
      return;
    }

    let suplementoDocModel: SuplementoModel = {
      nombre: this.formSuplemento.get('nombre').value,
      categoria: this.formSuplemento.get('categoria').value,
      marca: this.formSuplemento.get('marca').value ? this.formSuplemento.get('marca').value : '',
      porcion: this.formSuplemento.get('porcion').value,
      unidad: this.formSuplemento.get('unidad').value,
      calorias: this.formSuplemento.get('calorias').value,
      carbohidratos: this.formSuplemento.get('carbohidratos').value,
      azucar: this.formSuplemento.get('azucar').value != null ? this.formSuplemento.get('azucar').value : null,
      fibra: this.formSuplemento.get('fibra').value != null ? this.formSuplemento.get('fibra').value : null,
      proteinas: this.formSuplemento.get('proteinas').value,
      grasaTotal: this.formSuplemento.get('grasaTotal').value,
      grasaSaturada: this.formSuplemento.get('grasaSaturada').value != null ? this.formSuplemento.get('grasaSaturada').value : null,
      grasaMonoinsaturada: this.formSuplemento.get('grasaMonoinsaturada').value != null ? this.formSuplemento.get('grasaMonoinsaturada').value : null,
      grasaPoliinsaturada: this.formSuplemento.get('grasaPoliinsaturada').value != null ? this.formSuplemento.get('grasaPoliinsaturada').value : null,
      grasaTrans: this.formSuplemento.get('grasaTrans').value != null ? this.formSuplemento.get('grasaTrans').value : null,
      colesterol: this.formSuplemento.get('colesterol').value != null ? this.formSuplemento.get('colesterol').value : null,
      // imagenProducto: null,
      // imagenEtiqueta: null,
      informacion: this.formSuplemento.get('informacion').value,
      propietario: this.userInfo.documentContainerId,
      activo: true,
      empresaId: this.userInfo.empresaId
    };

    console.log('rawFileProducto', this.rawFileProducto)
    console.log('rawFileEtiquetaNutricional', this.rawFileEtiqueta)

    if(this.croppedImageProducto!='' && this.rawFileProducto!=null) suplementoDocModel.imagenProducto = { nombre: this.rawFileProducto.name, url: this.rawFileProducto.url };
    if(this.croppedImageEtiqueta!='' && this.rawFileEtiqueta!=null) suplementoDocModel.imagenEtiqueta =  { nombre:this.rawFileEtiqueta.name, url: this.rawFileEtiqueta.url };

    if(this.croppedImageProducto=='' && this.rawFileProducto==null && this.previewUrlProducto==null) suplementoDocModel.imagenProducto = null;
    if(this.croppedImageEtiqueta=='' && this.rawFileEtiqueta==null && this.previewUrlEtiqueta==null) suplementoDocModel.imagenEtiqueta = null;

    if(this.editarSuplemento) this.updateSuplementoFn(suplementoDocModel, this.editarSuplemento.documentId);
    if(!this.editarSuplemento) this.createSuplementoFn(suplementoDocModel);
  }
  createSuplementoFn(suplementoDocModel: SuplementoModel) {
    this.documentService.createDocumentInContainer(
      this.env.businessId,
      this.userInfo.documentContainerId,  //DocContId del usuario loggeado (email)
      null,
      this.pattern,
      null,
      suplementoDocModel,
    ).subscribe({
      next: (data) => {
          // debugger
          console.log(data);
          this.submitFormSuplemento = false;
          Swal.fire({
            position: "top-end",
            icon: "success",
            title: "Suplemento guardado con éxito",
            showConfirmButton: false,
            timer: 1500
          });
          $("#modal-suplemento").modal('hide');
          this.getSuplementos();
          this.inicializarFormSuplemento();
        },
      error: (error) => {
        console.error(error);
        //this.loading = false;
      },
    });
  }
  updateSuplementoFn(suplementoDocModel: SuplementoModel, documentId) {
    let title = '';
    if(suplementoDocModel.activo) title = "Suplemento actualizado con éxito";
    if(!suplementoDocModel.activo) title = "Suplemento eliminado con éxito";

    this.documentService
      .updateDocumentInContainer(
        this.env.businessId,
        this.userInfo.documentContainerId,  //DocContId del usuario loggeado (email)
        documentId,
        this.pattern,
        null,
        suplementoDocModel
      )
      .subscribe({
        next: (data) => {
          console.log(data);
          this.submitFormSuplemento = false;
          Swal.fire({
            position: "top-end",
            icon: "success",
            title: title,
            showConfirmButton: false,
            timer: 1500
          });
          $("#modal-suplemento").modal('hide');
          this.getSuplementos();
          this.inicializarFormSuplemento();
        },
        error: (error) => {
          console.error(error);
        },
      });
  }
  deleteSuplementoFn(suplementoDocModel) {
    Swal.fire({
      title: 'Eliminar suplemento',
      html: '¿Seguro que desea eliminar el suplemento: <b>"'+suplementoDocModel.nombre+'"</b>?',
      icon: 'warning',
      showCancelButton: true,
      cancelButtonText: 'Cancelar',
      confirmButtonColor: '#3085d6',
      cancelButtonColor: '#d33',
      confirmButtonText: 'Confirmar'
    }).then((result) => {
      if (result.isConfirmed) {
        suplementoDocModel.activo = false;
        this.updateSuplementoFn(suplementoDocModel, suplementoDocModel.documentId)
      }
    })
  }
  
  inicializarFormSuplemento()
  {
    this.editarSuplemento = false;
    // this.selectedImageProducto = null;
    // this.previewUrlProducto = null;
    // this.rawFileProducto = null;

    // this.selectedImageEtiquetaNutricional = null;
    // this.previewUrlEtiquetaNutricional = null;
    // this.rawFileEtiquetaNutricional = null;
    this.deleteImage('Producto');
    this.deleteImage('Etiqueta');

    const inputElement1 = document.getElementById('formFile1') as HTMLInputElement;
    if (inputElement1) inputElement1.value = ''; 

    const inputElement2 = document.getElementById('formFile2') as HTMLInputElement;
    if (inputElement2) inputElement2.value = ''; 

    this.enableOrDisableInputs(true);
    this.formSuplemento.setValue({
      nombre: '',
      categoria: '',
      marca: '',
      porcion: '',
      unidad: '',
      calorias:  '',
      carbohidratos: '',
      azucar: '',
      fibra: '',
      proteinas: '',
      grasaTotal: '',
      grasaSaturada: '', 
      grasaMonoinsaturada: '',
      grasaPoliinsaturada: '',
      grasaTrans: '',
      colesterol: '',
      informacion: '',
    })
  }
  enableOrDisableInputs(enable)
  {
    const controles = [
      'porcion',
      'unidad',
      'calorias',
      'carbohidratos',
      'azucar',
      'fibra',
      'proteinas',
      'grasaTotal',
      'grasaSaturada',
      'grasaMonoinsaturada',
      'grasaPoliinsaturada',
      'grasaTrans',
      'colesterol'
    ];
    controles.forEach(control => {
      const abstractControl = this.formSuplemento.get(control);
      if (abstractControl) {
        if(!enable) abstractControl.disable();
        if(enable) abstractControl.enable();
      }
    });
  }


  /******************* IMÁGENES ********************/
  // Propiedades para Image Cropper
  imageChangedEventProducto: any = '';
  imageChangedEventEtiqueta: any = '';
  croppedImageProducto: string = '';
  croppedImageEtiqueta: string = '';
  bolCroppedImgProducto: boolean = false;
  bolCroppedImgEtiqueta: boolean = false;
  rawFileProducto: any;
  rawFileEtiqueta: any;

  // Previsualización de las imágenes
  previewUrlProducto: string | null = null;
  previewUrlEtiqueta: string | null = null;

  fileChangeEvent(event: any, tipo: 'Producto' | 'Etiqueta'): void {
    const input = event.target as HTMLInputElement;
    if (input.files && input.files.length > 0) {
      const file = input.files[0];
      const reader = new FileReader();
      reader.onload = () => {
        if (tipo === 'Producto') {
          this.imageChangedEventProducto = event;
          this.bolCroppedImgProducto = true;
          this.rawFileProducto = {
            file: reader.result,
            type: file?.type,
            name: file?.name
          };
        } else {
          this.imageChangedEventEtiqueta = event;
          this.bolCroppedImgEtiqueta = true;
          this.rawFileEtiqueta = {
            file: reader.result,
            type: file?.type,
            name: file?.name
          };
        }
      };
      reader.readAsBinaryString(file);
    }
  }

  imageCropped(event: ImageCroppedEvent, tipo: 'Producto' | 'Etiqueta') {
    console.log("imageCropped()", event.base64)
    if (tipo === 'Producto') {
      this.croppedImageProducto = event.base64 || '';
      // this.previewUrlProducto = this.croppedImageProducto;
    } else {
      this.croppedImageEtiqueta = event.base64 || '';
      // this.previewUrlEtiqueta = this.croppedImageEtiqueta;
    }

    let croppedImage = event.base64.replace(/^data:.+;base64,/, '');
    let name = tipo === 'Producto' ? this.rawFileProducto.name : this.rawFileEtiqueta.name;
    let type = tipo === 'Producto' ? this.rawFileProducto.type : this.rawFileEtiqueta.type;
    this.uploadService.uploadImage(this.env.businessId, this.utilsService.create_UUID(), name, croppedImage, type).subscribe({
      next: (fileData: any) => {
        if (tipo === 'Producto') {
          this.rawFileProducto.url = fileData.fileName;
        } else {
          this.rawFileEtiqueta.url = fileData.fileName;
        }
      },
      error: (error) => {
        console.error(error)
      }
    })
  }

  imageLoaded(tipo: 'Producto' | 'Etiqueta') {
    console.log(`Image loaded for ${tipo}`);
  }

  cropperReady(event: any, tipo: 'Producto' | 'Etiqueta') {
    console.log(`Cropper ready for ${tipo}`, event);
  }

  loadImageFailed(tipo: 'Producto' | 'Etiqueta') {
    console.error(`Failed to load image for ${tipo}`);
    this.deleteImage(tipo);
  }

  deleteImage(tipo: 'Producto' | 'Etiqueta') {
    if (tipo === 'Producto') {
      this.imageChangedEventProducto = '';
      this.croppedImageProducto = '';
      this.bolCroppedImgProducto = false;
      this.previewUrlProducto = null;
      this.rawFileProducto = null;
    } else {
      this.imageChangedEventEtiqueta = '';
      this.croppedImageEtiqueta = '';
      this.bolCroppedImgEtiqueta = false;
      this.previewUrlEtiqueta = null;
      this.rawFileEtiqueta = null;
    }
  }

  get formSuplementoControl()
  {
    return this.formSuplemento.controls;
  }
}

